import { useMediaQuery } from "react-responsive";

/**
 * PC 화면인지 확인
 * @param minWidth - PC 기준 최소 스크린 너비
 */
export default function useCheckPC(minWidth = 1200): { isPC: boolean } {
  const isPC = useMediaQuery({ query: `(min-width: ${minWidth}px)` });
  return { isPC };
}
